import Project1 from "../../assets/image.png";



export const projectsData = [
    {
        id: 1,
        image: Project1,
        title: "كورس تأسيس النحو 🤍",
        category: "أ",
    },
    {
        id: 1,
        image: Project1,
        title: "كورس تأسيس النحو 🤍",
        category: "ب",
    },
    {
        id: 1,
        image: Project1,
        title: "كورس تأسيس النحو 🤍",
        category: "ج",
    },
];

export const projectsNav = [
    {
        name: "الكل",
    },
    {
        name: "أ",
    },
    {
        name: "ب",
    },
    {
        name: "ج",
    },
];